export const environment = {
  appConfigUrl: '/configs/config.json',
  production: false,
};
